module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAqElEQVRYR+2XMQ6AIAxFn4t30MN5DZ0cnOQaHk7v4KLBMBiCCVUimpS5//fzC21acO+UwAA0Dj4BPbBK6QopwMWPQOthDdBJ+e4KmIHKS7YA9VsCtotE4guJAS6xClAH1AF1IKkD58Hit1dpZ42Nt237GGC2E4YGSyzR0zhjBYQGy1PiWPzyCQHZS5D9EcbW6xyX9BuqAHVAHVAHfulA9tUs+3KabD3fAXgpLwmGSBo6AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/more-black.png
// module id = ccmQ
// module chunks = 1